import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3419">
      <Navbar data-id="element-3420" />
      <main data-id="element-3421">
        <ConsularAffairs data-id="element-3422" />
      </main>
      <Footer data-id="element-3423" />
      <FeedbackPopup data-id="element-3424" />
    </div>;
}